<template>
  <div>
    <Div v-if="transaction['api_result']['iframe']">
      <iframe
        ref="iframe"
        allow="camera; microphone"
        :src="transaction['api_result']['iframe']"
        frameBorder="0"
        class="iframe"
      />
    </Div>

    <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {},
  components: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    async send() {
      this.$loading(true);
      this.$emit("setStep", "tbc-add-card");
      this.$loading(false);
    },
  },
  data() {
    return {
      data: {},
    };
  },
};
</script>

